<template>
  <div id="app">
    <app-header />
    <app-sidebar />
    <router-view  keep-alive transition-mode="out-in" />
    <app-footer />
  </div>
</template>

<script>
import AppHeader from '@/components/Header.vue'
import Sidebar from '@/components/Sidebar.vue'
// import Aside from '@/components/Aside.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'default',
  components: {
    'app-header': AppHeader,
    'app-sidebar': Sidebar,
    // 'app-aside': Aside,
    'app-footer': Footer
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/default.vue